// Centralized logic for Demo Mode detection

export const isDemoMode = () => {
  // Check environment variable (build-time override)
  if (process.env.REACT_APP_USE_DEMO_MODE === 'true') {
    return true;
  }

  // Check hostname (runtime detection)
  if (typeof window !== 'undefined') {
    return window.location.hostname.startsWith('demo.');
  }

  return false;
};

// Helper to get the switch URL
export const getSwitchUrl = () => {
  if (typeof window === 'undefined') return '/';
  
  const isDemo = isDemoMode();
  const currentHost = window.location.host;
  const protocol = window.location.protocol;
  
  return isDemo 
    ? `${protocol}//${currentHost.replace('demo.', '')}` 
    : `${protocol}//demo.${currentHost}`;
};
